import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBiorhythmIntellectualIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.5455 14C18.5455 12.091 17.681 10.3902 16.3336 9.29135C15.3423 8.48273 14.0894 8 12.7273 8C9.51398 8 6.90909 10.6863 6.90909 14C6.90909 15.7944 7.6729 17.4048 8.88349 18.5043C6.16803 18.6165 4 20.9222 4 23.75C4 26.6495 6.27927 29 9.09091 29C11.1217 29 12.8749 27.7736 13.6919 26M16.3336 9.29135C17.4998 6.75443 20.0058 5 22.9091 5C26.4529 5 29.4048 7.61402 30.0506 11.0743M30.0506 11.0743C30.1367 11.5359 30.1818 12.0125 30.1818 12.5M30.0506 11.0743C33.0932 10.5414 36 13.039 36 16.25C36 19.1495 33.7207 21.5 30.9091 21.5C29.522 21.5 28.2644 20.9279 27.3463 20M20 35V34.7699C20 31.5833 22.505 29 25.5951 29C28.2621 29 30.5583 27.0587 31.0813 24.3617L31.6364 21.5",
		stroke: "#50E3C2",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBiorhythmIntellectualIcon;
